import { useQueryParam, withDefault } from "use-query-params";

import { PLATFORM_BREAKDOWN_ID } from "@features/sales-v4/constants";
import { CustomJsonCompressedParam } from "@north-beam/nb-common";

const SelectedBreakdownParam = CustomJsonCompressedParam<string[]>();

export const useSelectedBreakdownsQueryParams = () => {
  const [selectedBreakdownIds, setSelectedBreakdownIds] = useQueryParam(
    "selectedBreakdownIds",
    withDefault<string[], string[]>(SelectedBreakdownParam, [
      PLATFORM_BREAKDOWN_ID,
    ]),
    { updateType: "pushIn" },
  );

  return { selectedBreakdownIds, setSelectedBreakdownIds };
};
